'use strict';

module.exports = {
    FLOW_NAME_ACCOUNT: 'account',
    FLOW_NAME_BILLING_CHECKOUT: 'billing'
};
